import { WEBVIEW_ROUTES } from 'constants/routes';
import { WEBVIEW_SCREEN } from 'enums';

// Maps a webview pathname to the short, path-independent screen token the native
// shells expect in the readiness handshake. Screens outside the handshake return
// undefined (no signal is posted for them).
const WEBVIEW_PATH_TO_SCREEN: Record<string, WEBVIEW_SCREEN> = {
  [WEBVIEW_ROUTES.WEBVIEW_TOOLS_TODO_LIST]: WEBVIEW_SCREEN.TODO,
  [WEBVIEW_ROUTES.WEBVIEW_TODO_LIST]: WEBVIEW_SCREEN.TODO,
  [WEBVIEW_ROUTES.WEBVIEW_SETTINGS]: WEBVIEW_SCREEN.SETTINGS,
  [WEBVIEW_ROUTES.WEBVIEW_STATS]: WEBVIEW_SCREEN.STATS,
  [WEBVIEW_ROUTES.WEBVIEW_ROUTINE_SUGGESTION]: WEBVIEW_SCREEN.ROUTINE_SUGGESTIONS,
  [WEBVIEW_ROUTES.WEBVIEW_ROUTINE_SUGGESTION_REVAMP]:
    WEBVIEW_SCREEN.ROUTINE_SUGGESTIONS
};

// The subset of screens the Mac can switch to via window.fbNavigate (the shared "A2"
// tools WKWebView). Routine-suggestions is its own webview and is not fbNavigate-able.
const FB_NAVIGATE_SCREEN_TO_ROUTE: Partial<Record<WEBVIEW_SCREEN, string>> = {
  [WEBVIEW_SCREEN.TODO]: WEBVIEW_ROUTES.WEBVIEW_TOOLS_TODO_LIST,
  [WEBVIEW_SCREEN.SETTINGS]: WEBVIEW_ROUTES.WEBVIEW_SETTINGS,
  [WEBVIEW_SCREEN.STATS]: WEBVIEW_ROUTES.WEBVIEW_STATS
};

export const getWebviewScreenForPath = (
  pathname: string
): WEBVIEW_SCREEN | undefined => WEBVIEW_PATH_TO_SCREEN[pathname];

export const getRouteForFbNavigateScreen = (
  screen: string
): string | undefined => FB_NAVIGATE_SCREEN_TO_ROUTE[screen as WEBVIEW_SCREEN];
